/* eslint-disable spire/fenced-imports */
/* eslint-disable camelcase */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Product } from "@coveo/headless/commerce";
import { ProductSkeletonLoader } from "@DSG/Components/Coveo/CoveoSkeletonBox";
import useCoveoCommerceExtras from "@DSG/Components/Coveo/useCoveoCommerceExtras";
import colorPallete, { bodyFonts, labelFonts, themeFontWeights } from "@DSG/MobiusOverrides/styles/variables";
import { getSettingsCollection } from "@DSG/Overrides/Store/Context/ContextSelectors";
import { GetPreviousPurchaseHistory } from "@DSG/Services/DsgPreviousPurchaseHistoryService";
import CoveoApplicationState from "@DSG/Store/Data/CoveoApplicationState/CoveoApplicationState";
import { DISPATCH_SET_SEARCH_INPUT_QUERY } from "@DSG/Store/Reducer/CoveoCommerceReducer";
import { CoveoProductModel } from "@DSG/Type/CoveoModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import { Clickable, GridContainer, GridItem, Link } from "@insite/mobius/index";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    focusedItem?: CoveoProductModel;
    closeAutocomplete: () => void;
}
const mapStateToProps = (state: CoveoApplicationState) => ({
    isAuthenticated: state.context.session.isAuthenticated,
    language: state.context.session.language,
    roles: state.context.session.userRoles,
    currencySymbol: state.context.session.currency?.currencySymbol ?? "",
    coveoCommerce: state.DSGGlobalData,
    settings: getSettingsCollection(state),
});

export interface CoveoAutocompleteProductsStyles {
    wrapper?: InjectableCss;
    noProductFoundText?: TypographyPresentationProps;
    headingWrapper?: InjectableCss;
    leftHeadingGrid?: InjectableCss;
    searchTermHeadingWrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
    productsCountText?: TypographyPresentationProps;
    rightLinkGrid?: InjectableCss;
    viewAllLink?: InjectableCss;
    productWrapper?: InjectableCss;
    productGridContainer?: GridContainerProps;
    productGridItem?: GridItemProps;
    clickableWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    infoWrappwer?: InjectableCss;
    brandText?: TypographyPresentationProps;
    productNameText?: TypographyPresentationProps;
    productPartNumber?: InjectableCss;
    partNumber?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
    purchasedTagText?: TypographyPresentationProps;
}

export const coveoAutocompleteProductsStyles: CoveoAutocompleteProductsStyles = {
    headingWrapper: {
        css: css`
            display: flex;
            gap: 8px 16px;
            align-items: center;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    margin: 0 13px;
                    width: calc(100% - 26px);
                `,
            ], "max")}   
        `
    },
    noProductFoundText: {
        variant: "h6",
        css: css`
            margin: 0;
            display: flex;
            min-height: 90px;
            align-items: center;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                    line-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                `,
            ], "max")}  
        `
    },  
    leftHeadingGrid:{
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    min-height: 56px;
                    display: flex;
                    align-items: center;
                `,
            ], "min")}   
        `
    },
    searchTermHeadingWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `
    },
    headingText: {
        variant: "h6",
        css: css`
            margin: 0;
            &.searchTermHeading {
                word-break: break-word;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                    line-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                `,
            ], "max")}  
        `
    },
    productsCountText: {
        css: css`
            font: ${labelFonts.label1Regular.fontWeight} ${labelFonts.label1Regular.fontSize}/${labelFonts.label1Regular.lineHeight} ${labelFonts.label1Regular.fontFamily};
            color: ${colorPallete.grey800};
        `
    },
    viewAllLink: {
        css: css`
            font: ${labelFonts.label1SemiBold.fontWeight} ${labelFonts.label1SemiBold.fontSize}/${labelFonts.label1SemiBold.lineHeight} ${labelFonts.label1SemiBold.fontFamily};      
        `
    },
    productWrapper: {
        css: css`      
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    padding: 0 9px;
                `,
            ], "min")}   
        `
    },
    productGridContainer: {
        gap: 8,
        css: css`
            margin-top: 8px;
            > div[class*="GridOffset"] {
                gap: 8px;
                margin: 0;
                width: 100%;
            }
        `
    },
    productGridItem: {
        width: 12,
    },
    clickableWrapper: {
        css: css`
            padding: 7px 16px;
            border-radius: 8px;
            border: 1px solid ${colorPallete.grey300};
            display: flex;
            align-items: center;
            column-gap: 24px;
            width: 100%;
            min-height: 96px;
        `
    },
    imageWrapper: {
        css: css`
            width: 80px;
            min-width: 80px;
            display: flex;
            img {
                min-width: 80px;
                max-width: 80px;
                width: auto;
                height: auto;
            }
        `
    },
    infoWrappwer: {
        css: css`
            width: calc(100% - 80px);
            display: flex;
            flex-direction: column;
        `
    },
    brandText: {
        css: css`
            font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
            color: ${colorPallete.grey600};
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
        `
    },
    productNameText: {
        css: css`
            font-weight: ${themeFontWeights.semiBold};
            font-size: 11px;
            line-height: 150%;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            color: ${colorPallete.black90};
            margin-bottom: 4px;
        `
    },
    productPartNumber: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            gap: 4px 16px;   
        `
    },
    partNumber: {
        css: css`
            display: flex;
            gap: 2px;
        `
    },
    labelText: {
        css: css`
            font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
            color: ${colorPallete.grey600DisabledText};
        `
    },
    valueText: {
        css: css`
            font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
            color: ${colorPallete.grey800};
        `
    },
    purchasedTagText: {
        css: css`
            font: italic ${labelFonts.label2SemiBold.fontWeight} ${labelFonts.label2SemiBold.fontSize}/${labelFonts.label2SemiBold.lineHeight} ${labelFonts.label2SemiBold.fontFamily};
            border-radius: 4px;
            padding: 2px 8px;
            min-height: 24px;
            display: inline-flex;
            text-transform: uppercase;
            background: ${colorPallete.semanticBlueTagBg};
            margin-top: 4px;
            align-items: center;
            color: ${colorPallete.secondaryNavy500}
        `
    }
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const styles = coveoAutocompleteProductsStyles;

const CoveoAutocompleteProducts = ({
    closeAutocomplete,
    coveoCommerce,
    isAuthenticated,
    settings,
}: Props) => {
    const dispatch = useDispatch();
    const [coveoProducts, setCoveoProducts] = useState<CoveoProductModel[]>([]);
    const { doCoveoSearch, clearSearchAndProductValues } = useCoveoCommerceExtras(coveoCommerce);
    const [coveoProductsNumber, setCoveoProductsNumber] = useState<any[]>([]);
    const [previousPurchaseData, setPreviousPurchaseData] = useState<any[]>([]);
    const allSettings = settings as any;
    // const productSettings = allSettings.productSettings;
    const catalogSettings = allSettings.catalogUrlSettings;
    const catalogleneralsettings = allSettings.catalogGeneralSettings;

    useEffect(() => {
        const coveoProducts: CoveoProductModel[] = [];
        const coveoProductNumber:any[] =[];
        
        let index = 0;
        coveoCommerce?.InstantProductsState?.products.forEach((_product: Product) => {
            const product = _product;
            if (!coveoCommerce?.InstantProductsController) { return; }
    
            const interactiveProduct = coveoCommerce?.InstantProductsController?.interactiveProduct({ options: { product } });

            const ec_product_id = product.additionalFields?.ec_productname;
            const pid = ec_product_id as string;

            let minimumOrderQty = product.additionalFields?.ec_minimum_order_qty as string;
            minimumOrderQty = minimumOrderQty === "0" ? "1" : minimumOrderQty;
            coveoProductNumber.push({productNumber:product.additionalFields?.ec_productname as string});
     
            const exists = coveoProducts.some(p => p.productNumber === product.additionalFields?.ec_productname);

            if (!exists) {
                coveoProducts.push({
                    title: product.ec_name as string,
                    brandName: product.ec_brand as string,
                    categoryName: product.ec_category,
                    subBrandName:product.additionalFields?.ec_brand_name_sub ?? "",
                    shortDescription: product.ec_shortdesc as string,
                    productNumber: product.additionalFields?.ec_productname as string, // erp_number as string,
                    manufacturerItem: product.additionalFields?.ec_manufactureritem as string,
                    availability: product.additionalFields?.ec_availability as [],
                    urlSegment: `/${catalogSettings.productRootPath}/${product.additionalFields?.ec_productname}` as string,
                    imageAltText: product.additionalFields?.ec_productname as string,
                    mediumImagePath: (catalogleneralsettings.notFoundMediumImagePath) as string,
                    smallImagePath: ((product.additionalFields?.ec_smallimagepath && product.additionalFields?.ec_smallimagepath !== "") ? product.additionalFields?.ec_smallimagepath : catalogleneralsettings.notFoundSmallImagePath) as string,
                    // variantTypeId,
                    canAddToCart: false,
                    quoteRequired: false,
                    minimumOrderQty: minimumOrderQty as string,
                    allowZeroPricing: false,
                    unitListPrice: 0,
                    unitofmeasure: "",
                    productId: pid as string,
                    canonicalUrl: product.clickUri as string,
                    pricing: null,
                    saleType: "",
                    onSaleNow: "",
                    brandUrlSegment: `${catalogSettings.brandrootpath}/${product.ec_brand}` as string,
                    showAuthorizationRequired: false,
                    responseId: "",
                    customerProductNumber: product.additionalFields?.ec_customer_product_number as string,
                    previousPurchaseDate: "",
                    upcCode: "",
                    inventory: undefined,
                    interactiveProduct,
                    isdiscontinued: product.additionalFields?.ec_isdiscontinued ?? false,
                   
                });
            }           
            index++;
        });
        
        setCoveoProductsNumber(coveoProductNumber);
        setCoveoProducts(coveoProducts);
    }, [coveoCommerce?.InstantProductsState]);

    useEffect(() => {
        if(coveoProductsNumber.length > 1 && isAuthenticated){
            const fetchPrevePurchaseData = async () => {
                const prevPurchaseDate= await GetPreviousPurchaseHistory(coveoProductsNumber);
            
                if(prevPurchaseDate !== undefined){
                    setPreviousPurchaseData(prevPurchaseDate);
                }
            }
            fetchPrevePurchaseData();
        }
    }, [coveoProductsNumber]);
    
    const handleProductClick = (product: CoveoProductModel) => {
        closeAutocomplete();
        clearSearchAndProductValues();
        
        // Emit the Coveo Product Click Event
        product.interactiveProduct?.select();
    };

    const getPrevPurchaseDate = (product: CoveoProductModel) => {
        const prevProduct = previousPurchaseData.find((item) => item.productNumber === product.productNumber);
        return prevProduct ? prevProduct.previouslyPurchaseDate : '';
    };
   
    const handleOnClick = (query : string) => {
        dispatch({
            type: DISPATCH_SET_SEARCH_INPUT_QUERY,
            query
        })
    };

    const suggestionsKeywordIndex = coveoCommerce?.SelectedSuggestionIndex as any;
    const suggestionsKeyword = coveoCommerce?.SearchBoxState?.suggestions[suggestionsKeywordIndex]?.rawValue;
    const query = coveoCommerce?.SearchInputQuery;

    const isLoading = coveoCommerce?.InstantProductsState?.isLoading;
    if (!coveoCommerce?.InstantProductsState) { return null; }
   
    return (
        <StyledWrapper {...styles.wrapper} className="coveoProductListWrapper"> 
            <StyledWrapper {...styles.headingWrapper}>
                <StyledWrapper {...styles.leftHeadingGrid}>
                    {coveoCommerce?.InstantProductsState && query.length >= 1 && 
                        <StyledWrapper {...styles.searchTermHeadingWrapper}>
                            <Typography {...styles.headingText} className="searchTermHeading">
                                {suggestionsKeyword ? suggestionsKeyword?.charAt(0).toUpperCase() + suggestionsKeyword?.slice(1) : suggestionsKeyword}
                            </Typography>
                            
                            <Typography {...styles.productsCountText}> 
                                {translate(` (1-${coveoProducts.slice(0, 4).length || 0} ${translate('of')} ${coveoCommerce?.InstantProductsState?.totalCount?.toLocaleString() || 0} ${coveoCommerce?.InstantProductsState?.totalCount === 1 ? translate('product') : translate('products')})`)}
                            </Typography>
                        </StyledWrapper>
                    }
                    {query.length === 0 &&
                        <Typography {...styles.headingText}>
                            {translate("Suggested for You")}
                        </Typography>
                    }
                </StyledWrapper>
                <StyledWrapper {...styles.rightLinkGrid}>
                    {suggestionsKeyword && (
                        <Link {...styles.viewAllLink}  
                            onClick={() => {
                                closeAutocomplete();
                                handleOnClick(suggestionsKeyword);
                                doCoveoSearch(suggestionsKeyword);
                            }} 
                            className="text-link-primary text-link-active">
                            {translate("View all results")}
                        </Link>
                    )}
                    
                </StyledWrapper>
            </StyledWrapper>
          
            {isLoading && (
                <ProductSkeletonLoader numberOfSuggestions={4} />
            )}
          
            {!isLoading && (
                <StyledWrapper {...styles.productWrapper}>
                    <GridContainer {...styles.productGridContainer}>
                        {coveoProducts.slice(0, 4).map((item)=> (
                            <GridItem {...styles.productGridItem} key={item.productNumber}>
                                <Clickable href={item.urlSegment} 
                                    onClick={() => {
                                        handleProductClick(item);
                                        closeAutocomplete();
                                    }}
                                    {...styles.clickableWrapper}
                                >
                                    <StyledWrapper {...styles.imageWrapper}>
                                        <Img src={item.smallImagePath} altText={item.imageAltText} />
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.infoWrappwer}>
                                        {item.brandName && (
                                            <Typography {...styles.brandText}>
                                                {item.subBrandName && (item.subBrandName)}
                                                {item.subBrandName && translate(" by ")}
                                                {item.brandName}
                                            </Typography>
                                        )}
                                        {item.title && (
                                            <Typography {...styles.productNameText}>
                                                {item.title}
                                            </Typography>
                                        )}
                                        <StyledWrapper {...styles.productPartNumber}>
                                            {item.manufacturerItem && (
                                                <StyledWrapper {...styles.partNumber}>
                                                    <Typography {...styles.labelText}>{translate("MFG Part#")}</Typography>                                                    
                                                    <Typography {...styles.valueText}>{item.manufacturerItem}</Typography>                                                    
                                                </StyledWrapper>
                                            )}
                                            {item.productNumber && (
                                                <StyledWrapper {...styles.partNumber}>
                                                    <Typography {...styles.labelText}>{translate("DSG#")}</Typography>                                                    
                                                    <Typography {...styles.valueText}>{item.productNumber}</Typography>                                                    
                                                </StyledWrapper>
                                            )}
                                            {item.customerProductNumber && (
                                                <StyledWrapper {...styles.partNumber}>
                                                    <Typography {...styles.labelText}>{translate("My Part#")}</Typography>                                                    
                                                    <Typography {...styles.valueText}>{item.customerProductNumber}</Typography>                                                    
                                                </StyledWrapper>
                                            )}
                                        </StyledWrapper>
                                        {getPrevPurchaseDate(item) &&(
                                            <StyledWrapper>
                                                <Typography {...styles.purchasedTagText}>{translate("Last Purchased")} {getPrevPurchaseDate(item)}</Typography>
                                            </StyledWrapper>
                                        )}
                                    </StyledWrapper>
                                </Clickable>
                            </GridItem>
                        ))}
                    </GridContainer>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
}

export default connect(mapStateToProps)(CoveoAutocompleteProducts);